/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum COLOR {
	DEFAULT = "default",
	PRIMARY = "primary",
	ERROR = "error",
	WARNING = "warning",
	SUCCESS = "success",
	INFO = "info",
	HINT = "hint"
}
